/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';

export default {
	normal: __( 'Normal', 'woocommerce-payments' ),
	elevated: __( 'Elevated', 'woocommerce-payments' ),
	highest: __( 'Highest', 'woocommerce-payments' ),
	not_assessed: __( 'N/A', 'woocommerce-payments' ),
	unknown: __( 'N/A', 'woocommerce-payments' ),
};
